import HttpClient from "./index"
import ApiRoutes, { baseUrl } from "../config/endpoints"

export default class HelpCenterAPI extends HttpClient {
  constructor() {
    super(baseUrl)
    this._initializeRequestInterceptor()
  }

  //Help Center
  createResource = ApiRoutes.HelpCenter.CreateResource
  folderDelete = ApiRoutes.HelpCenter.FolderDelete
  fileDelete = ApiRoutes.HelpCenter.FileDelete
  updateFile = ApiRoutes.HelpCenter.UpdateFileById
  addAttachment = ApiRoutes.HelpCenter.AddAttachment

  // remaining
  fileUpload = ApiRoutes.HelpCenter.FileUpload
  fetchHelpCenterData = ApiRoutes.HelpCenter.FetchHelpCenter

  _initializeRequestInterceptor = () => {
    this.instance.interceptors.request.use(this._handleRequest)
  }

  _handleRequest = async (axiosConfig: any) => {
    return axiosConfig
  }

  createNewResource = (token: string, data: any) => {
    return this.instance({
      method: this.createResource.Method,
      url: this.createResource.EndPoint,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
      data,
    })
  }

  deleteDirectory = (token: string, id: string) => {
    return this.instance({
      method: this.folderDelete.Method,
      url: this.folderDelete.EndPoint(id),
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
  }
  deleteDocument = (token: string, id: string) => {
    return this.instance({
      method: this.fileDelete.Method,
      url: this.fileDelete.EndPoint(id),
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
  }
  UpdateResource = (token: string, id: string, data: any) => {
    return this.instance({
      method: this.updateFile.Method,
      url: this.updateFile.EndPoint(id),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data,
    })
  }
  addAttachmentToResource = (token: string, id: string, data: any) => {
    return this.instance({
      method: this.addAttachment.Method,
      url: this.addAttachment.EndPoint(id),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data,
    })
  }
  // remaining

  uploadAttachmentToS3 = (token: string) => {
    return this.instance({
      method: this.addAttachment.Method,
      url: this.addAttachment.EndPoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      //   data: {
      //     group_list: groups,
      //     region_list: regions,
      //   },
    })
  }
  FetchHelpCenter = (token: string) => {
    return this.instance({
      method: this.fetchHelpCenterData.Method,
      url: this.fetchHelpCenterData.EndPoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
  }
}
